import {
	AlertDialog as ADialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export function AlertDialog({ children, onClick, description }: { children: React.ReactNode; description: string; onClick: () => void }) {
	return (
		<ADialog>
			<AlertDialogTrigger asChild>
				{children}
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
					<AlertDialogDescription>
						{description}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>Cancel</AlertDialogCancel>
					<AlertDialogAction asChild onClick={onClick}>
						<Button variant="destructive">Continue</Button>
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</ADialog>
	);
}
